// extracted by mini-css-extract-plugin
module.exports = {"exitButton":"ExitButton-module__exitButton--2iIt_","exitButtonAbsolute":"ExitButton-module__exitButtonAbsolute--3r78S"};